import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weekendMore = useStore((state) => state.weekendMore);
  const setWeekendMore = useStore((state) => state.setWeekendMore);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weekendMore.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={weekendMore}
          onChange={(value) => {
            setWeekendMore(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weekend-more',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Yes"}>
            <span>✅</span> {t('onboarding.weekendMore.options.yes')}
          </Option>
          <Option value={"No"}>
            <span>❌</span> {t('onboarding.weekendMore.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
